import { schema, types } from 'papr'

export const personalAccessTokenSchema = schema(
	{
		userId: types.objectId({ required: true }),
		tokenValue: types.string({ required: true }),
		// Removed the required because we should use the built-in field createdAt instead.
		dateAdded: types.date(),
		isActive: types.boolean(),
		isPrivate: types.boolean(),
	},
	{
		defaults: {
			isPrivate: false,
		},
		timestamps: true,
	},
)

export const createPersonalAccessTokenIndex = async (db) => {
	await db.createIndex('personalaccesstokens', { tokenValue: 1 }, { unique: true })
}

export type PersonalAccessTokenDocument = (typeof personalAccessTokenSchema)[0]
export type PersonalAccessTokenSchemaOptions = (typeof personalAccessTokenSchema)[1]
